module.exports = __webpack_public_path__ + "assets/media/prize-error.f39f6e82.svg";